import React, { ReactElement } from 'react';

import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';
import { CellTypeFormatChanges, CellTypeObjectWithAuto } from '../../../../../../common/table/TableTypes';
import SheetContainer, { Content, Overlay, Sheet } from '../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../mobile/structural/sheet/hooks/useSheet';
import CellTypeFormatContent from '../../../../../element/table/cellTypes/CellTypeFormatContent';

import './MobileCellTypeFormatSheet.scss';

type Props = {
    sheetProps: UseSheetReturnType;
    currentCellType: CellTypeNames;
    sharedCellTypeFormatOptions: CellTypeObjectWithAuto;
    locale: string;
    updateCellTypeFormat: (cellTypeFormatChanges: CellTypeFormatChanges) => void;
};

const MobileCellTypeFormatSheet = (props: Props): ReactElement => {
    const { sheetProps, ...formattingOptionsProps } = props;

    return (
        <SheetContainer className="MobileCellTypeFormatSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <div className="MobileCellTypeFormatSheetPopup" data-table-util>
                        <CellTypeFormatContent {...formattingOptionsProps} formSize="md" />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileCellTypeFormatSheet;
